export default "__VITE_PUBLIC_ASSET__569c8821__"